import Vue from 'vue';
import AsyncComputed from 'vue-async-computed';
import VueLazyImageLoading from 'vue-lazy-image-loading';
import VueChatScroll from 'vue-chat-scroll';
import TextareaAutosize from 'vue-textarea-autosize';
import App from './App.vue';
import store from './store';
import './registerServiceWorker';
import VueCookie from 'vue-cookie';

Vue.use(AsyncComputed);
Vue.use(VueLazyImageLoading);
Vue.use(VueChatScroll);
Vue.use(TextareaAutosize);
Vue.use(VueCookie);
Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
